/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const DealStage = {
  InProgress: 0,
  ClosedWon: 1,
  ClosedLost: 2,
} as const;

export type DealStage = typeof DealStage[keyof typeof DealStage];
